import { BDropdownItem } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBDropdownItem when migrating. */
export const EgBDropdownItem = createEgBootstrapProxy(
  "EgBDropdownItem",
  BDropdownItem
);
